import { render } from "./commercial_ethics.vue?vue&type=template&id=29bf9590&scoped=true"
import script from "./commercial_ethics.vue?vue&type=script&lang=js"
export * from "./commercial_ethics.vue?vue&type=script&lang=js"

import "./commercial_ethics.vue?vue&type=style&index=0&id=29bf9590&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bf9590"]])

export default __exports__